import {
  PRODUCT_MODE,
  PRODUCT_MODE_COOKIE_KEY,
  RECENT_PROJECTS_VIEW,
} from '@src/constants/educators';
import { DUBBING_PANEL_VIEW } from '@src/constants/dubbing';
import { getCookie } from '@src/utils/cookie';
import { actionTypes } from './actions';

export const initialState = {
  // Anything other than the educators mode falls back to studio, so a stale or
  // hand-edited value cannot break the sidebar.
  productMode:
    getCookie(PRODUCT_MODE_COOKIE_KEY) === PRODUCT_MODE.EDUCATORS
      ? PRODUCT_MODE.EDUCATORS
      : PRODUCT_MODE.STUDIO,
  openSidebar: true,
  openHighlightWeekDialog: false,
  isPlayingVoicePodium: false,
  showPackageExpiringSoon: true,
  showNotifyLowCredits: true,
  showOnboardingPopup: false,
  showOnboardingTasks: false,
  showOnboardingPopupMobile: false,
  taskCompletedData: null,
  showCompleteTaskSurveyDialog: false,
  isPanelResizeDisabled: false,
  // Lives here rather than in the list, which unmounts on the way to another
  // page and would come back showing the grid whatever was picked last.
  recentProjectsView: RECENT_PROJECTS_VIEW.GRID,
  // Not in `project`: undo/redo diffs that slice and would move the panel.
  dubbingPanelView: DUBBING_PANEL_VIEW.BLOCK_LIST,
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCT_MODE:
      return { ...state, productMode: action.productMode };

    case actionTypes.HANDLE_CHANGE_OPEN_SIDEBAR:
      return { ...state, openSidebar: action.openSidebar };

    case actionTypes.OPEN_HIGHLIGHT_WEEK_DIALOG:
      return {
        ...state,
        openHighlightWeekDialog: action.open,
      };

    case actionTypes.SET_IS_PLAYING_VOICE_PODIUM:
      return {
        ...state,
        isPlayingVoicePodium: action.isPlaying,
      };

    case actionTypes.SET_SHOW_PACKAGE_EXPIRING_SOON:
      return {
        ...state,
        showPackageExpiringSoon: action.showPackageExpiringSoon,
      };

    case actionTypes.SET_SHOW_NOTIFY_LOW_CREDITS:
      return {
        ...state,
        showNotifyLowCredits: action.showNotifyLowCredits,
      };

    case actionTypes.SET_SHOW_ONBOARDING_POPUP:
      return {
        ...state,
        showOnboardingPopup: action.showOnboardingPopup,
      };

    case actionTypes.SET_SHOW_ONBOARDING_TASKS:
      return {
        ...state,
        showOnboardingTasks: action.showOnboardingTasks,
      };

    case actionTypes.SET_SHOW_ONBOARDING_POPUP_MOBILE:
      return {
        ...state,
        showOnboardingPopupMobile: action.showOnboardingPopupMobile,
      };

    case actionTypes.SET_TASK_COMPLETED_DATA:
      return {
        ...state,
        taskCompletedData: action.taskCompletedData,
      };

    case actionTypes.SET_SHOW_COMPLETE_TASK_SURVEY_DIALOG:
      return {
        ...state,
        showCompleteTaskSurveyDialog: action.showCompleteTaskSurveyDialog,
      };

    case actionTypes.SET_IS_PANEL_RESIZE_DISABLED:
      return {
        ...state,
        isPanelResizeDisabled: action.isDisabled,
      };

    case actionTypes.SET_RECENT_PROJECTS_VIEW:
      return {
        ...state,
        recentProjectsView: action.recentProjectsView,
      };

    // Every project open resets this to the value already there.
    case actionTypes.SET_DUBBING_PANEL_VIEW:
      if (state.dubbingPanelView === action.dubbingPanelView) return state;
      return {
        ...state,
        dubbingPanelView: action.dubbingPanelView,
      };

    default:
      return state;
  }
};

export default layoutReducer;
